/* eslint-disable jsdoc/check-param-names */
import { Brick, registerBrick, BrickContext } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class BuildPurchaseGroupMassChangeRequestFilter extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} approvers
     * @param {*} companyCodes
     * @param {*} plants
     * @param {*} purchasingOrganization
     * @param {*} purchasingGroups
     * @param {*} releaseGroups
     * @param {*} releaseCodes
     * @param {*} positions
     * @param {function(string): void} setFilter
     */
    update(
        $,
        [
            approvers,
            companyCodes,
            plants,
            purchasingOrganization,
            purchasingGroups,
            releaseGroups,
            releaseCodes,
            positions,
        ],
        [setFilter]
    ) {
        const logger = getLogger('BuildPurchaseGroupMassChangeRequestFilter');

        logger.debug('Building Purchase Group request path with');
        logger.debug('approvers', approvers);
        logger.debug('companyCodes', companyCodes);
        logger.debug('plants', plants);
        logger.debug('purchasingOrganization', purchasingOrganization);
        logger.debug('purchasingGroups', purchasingGroups);
        logger.debug('releaseGroups', releaseGroups);
        logger.debug('releaseCodes', releaseCodes);
        logger.debug('positions', positions);

        const paths = [];

        const addPath = (key, values) => {
            paths.push(`(${values.map((value) => `${key} eq '${value}'`).join(' or ')})`);
        };

        if (approvers?.length) {
            // TODO: Confirm
            addPath('AgentId', approvers);
        }

        if (positions?.length) {
            addPath('AgentId', positions);
        }

        if (companyCodes?.length) {
            addPath('CompanyCode', companyCodes);
        }

        if (plants?.length) {
            addPath('Plant', plants);
        }

        if (purchasingOrganization?.length) {
            addPath('PurchOrg', purchasingOrganization);
        }

        if (purchasingGroups?.length) {
            addPath('PurchGrp', purchasingGroups);
        }

        if (releaseGroups?.length) {
            addPath('RelGroup', releaseGroups);
        }

        if (releaseCodes?.length) {
            addPath('RelCode', releaseCodes);
        }

        const finalPath = paths.join(' and ');
        logger.debug('finalPath', finalPath);
        setFilter(finalPath);
    }
}

registerBrick('018c45091cd65eb8bcb5', BuildPurchaseGroupMassChangeRequestFilter);
